import axios from 'axios';

const endpoint = '/widget';

const state = {
  data: {},
  highlights: {},
  department: '',
};

const mutations = {
  data(state, value) {
    state.data = value;
  },
  highlights(state, value) {
    state.highlights = value;
  },
  view(state, value) {
    state.view = value;
  },
  department(state, value) {
    state.department = value;
  },
};

const actions = {
  get({ commit }, params = '') {
    return new Promise((resolve, reject) => {
      axios.get(`${endpoint}?${params}`)
        .then(({ data }) => {
          commit('data', data);
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  patch({ dispatch }) {
    return new Promise((resolve, reject) => {
      const { id } = state.data.data[0];
      axios.patch(`${endpoint}/${id}`, state.data.data[0])
        .then(() => {
          dispatch('get')
            .then(data => resolve(data))
            .catch(error => reject(error));
        })
        .catch(error => reject(error));
    });
  },
  set({ commit }, { value, key }) {
    const original = state.data;
    const obj = state.data.data[0];

    function set(path) {
      let schema = obj; // a moving reference to internal objects within obj
      const pList = path.split('.');
      const len = pList.length;
      for (let i = 0; i < len - 1; i++) {
        const elem = pList[i];
        if (!schema[elem]) schema[elem] = {};
        schema = schema[elem];
      }
      schema[pList[len - 1]] = value;
    }

    set(key);

    original.data[0] = obj;
    commit('data', original);
  },
  getKey({ dispatch }, foo) {
    return new Promise((resolve, reject) => {
      if ('data' in state.data) {
        const getNestedObject = (nestedObj, pathArr) => pathArr.reduce((obj, key) => ((obj && obj[key] !== 'undefined') ? obj[key] : undefined), nestedObj);
        const obj = state.data.data[0];
        const result = getNestedObject(obj, foo.split('.'));
        if (result) resolve(result);
        else reject();
      } else {
        setTimeout(() => dispatch('getKey', foo).then(value => resolve(value)), 50);
      }
    });
  },
};

const getters = {
  data: state => state.data,
  department: state => state.department,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
